import React from 'react';
import styles from './styles.module.scss';

interface IProps {
    value: string;
    disabled: boolean;
    onChange: (value: string) => void;
    onBlur?: () => void;
}

const EditableCell: React.FC<IProps> = ({value, disabled, onChange, onBlur}) => {
    if (disabled) {
        return <span className={styles.editableCell__readonly}>{value}</span>;
    }

    return (
        <textarea
            className={styles.editableCell__textarea}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
        />
    );
};

export default EditableCell;
